import React from 'react';
import { ShieldCheck, Clock, Users, Award, Headphones, ThumbsUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = [
    {
      title: t('home.whyChoose.reasons.expert.title'),
      desc: t('home.whyChoose.reasons.expert.desc'),
      icon: <Users className="text-white" size={24} />
    },
    {
      title: t('home.whyChoose.reasons.fast.title'),
      desc: t('home.whyChoose.reasons.fast.desc'),
      icon: <Clock className="text-white" size={24} />
    },
    {
      title: t('home.whyChoose.reasons.partner.title'),
      desc: t('home.whyChoose.reasons.partner.desc'),
      icon: <ShieldCheck className="text-white" size={24} />
    },
    {
      title: t('home.whyChoose.reasons.custom.title'),
      desc: t('home.whyChoose.reasons.custom.desc'),
      icon: <ThumbsUp className="text-white" size={24} />
    },
    {
      title: t('home.whyChoose.reasons.rates.title'),
      desc: t('home.whyChoose.reasons.rates.desc'),
      icon: <Award className="text-white" size={24} />
    },
    {
      title: t('home.whyChoose.reasons.support.title'),
      desc: t('home.whyChoose.reasons.support.desc'),
      icon: <Headphones className="text-white" size={24} />
    }
  ];

  return (
    <section className="py-20 bg-cream-off">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-green mb-4">{t('home.whyChoose.title')}</h2>
          <div className="w-24 h-1 bg-gold-primary mx-auto"></div>
          <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
            {t('home.whyChoose.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow border border-gold-light/20 group">
              <div className="w-14 h-14 bg-dark-green rounded-lg flex items-center justify-center mb-6 group-hover:bg-gold-primary transition-colors">
                {reason.icon}
              </div>
              <h3 className="text-xl font-bold text-dark-green mb-3">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
